<div class="sign-status-container">
  @if (preloader) {
    <libero-preload-spinner></libero-preload-spinner>
  }
  @if (errored) {
    {{ 'additionalSignLandingPage.errored' | translate }}
  }
  @if (notFoundWithToken) {
    {{ 'additionalSignLandingPage.notFoundWithToken' | translate }}
  }
  @if (success) {
    <p class="success-text success-text--highlighted">{{ 'additionalSignLandingPage.signSuccess1' | translate }}</p>
    <p class="success-text">{{ 'additionalSignLandingPage.signSuccess2' | translate }}</p>
  }
</div>